import wx from 'weixin-js-sdk';
import request from '@/utils/request'
import qs from "qs";
export function wxshare(titles, descs, imgurls) {
    return request.post('cms/wechat/permit/doShare.do', qs.stringify({
        url: window.location.href
    })).then(res => {
        wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: res.obj.appId, // 必填，公众号的唯一标识
            timestamp: res.obj.timestamp, // 必填，生成签名的时间戳
            nonceStr: res.obj.nonceStr, // 必填，生成签名的随机串
            signature: res.obj.signature, // 必填，签名，见附录1
            // jsApiList: ["onMenuShareTimeline", "onMenuShareAppMessage"] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
            jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage', 'hideAllNonBaseMenuItem', 'showMenuItems']
        });
        wx.ready(function() {
            // wx.hideAllNonBaseMenuItem();
            wx.showMenuItems({
                menuList: [
                        "menuItem:share:timeline",
                        'menuItem:share:appMessage'
                    ] // 要显示的菜单项，所有menu项见附录3
            });

            //分享朋友圈
            wx.onMenuShareTimeline({
                title: titles, // 分享标题
                desc: descs, // 分享描述
                link: window.location.href, // 分享链接
                imgUrl: imgurls, // 分享图标
                success: function() {
                    // 用户确认分享后执行的回调函数
                },
                cancel: function() {
                    // 用户取消分享后执行的回调函数
                }
            });
            // 分享好友
            wx.onMenuShareAppMessage({
                title: titles, // 分享标题
                desc: descs, // 分享描述
                link: window.location.href, // 分享链接
                imgUrl: imgurls, // 分享图标
                type: "", // 分享类型,music、video或link，不填默认为link
                dataUrl: "", // 如果type是music或video，则要提供数据链接，默认为空
                success: function() {},
                cancel: function() {
                    // 用户取消分享后执行的回调函数
                }
            });
        });

    })

}

export function wxunshare() {
    return request.post('cms/wechat/permit/doShare.do', qs.stringify({
        url: window.location.href
    })).then(res => {
        wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: res.obj.appId, // 必填，公众号的唯一标识
            timestamp: res.obj.timestamp, // 必填，生成签名的时间戳
            nonceStr: res.obj.nonceStr, // 必填，生成签名的随机串
            signature: res.obj.signature, // 必填，签名，见附录1
            // jsApiList: ["onMenuShareTimeline", "onMenuShareAppMessage"] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
            jsApiList: ['chooseImage', 'previewImage', 'hideAllNonBaseMenuItem'],
            openTagList: ['wx-open-launch-weapp']
        });

        wx.ready(function() {
            //分享朋友圈
            wx.hideAllNonBaseMenuItem();
        });
    })

}


export function checkFollow() {
    return request.post('cms/wechat/permit/doShare.do', qs.stringify({
        url: window.location.href
    })).then(res => {
        wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: res.obj.appId, // 必填，公众号的唯一标识
            timestamp: res.obj.timestamp, // 必填，生成签名的时间戳
            nonceStr: res.obj.nonceStr, // 必填，生成签名的随机串
            signature: res.obj.signature, // 必填，签名，见附录1
            // jsApiList: ["onMenuShareTimeline", "onMenuShareAppMessage"] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
            jsApiList: ['checkJsApi', 'updateAppMessageShareData', 'updateTimelineShareData'],
        });

        wx.ready(function() {
            wx.checkJsApi({
                jsApiList: ['checkSubscribeMessages'],
                success: function(res) {
                    // 如果支持checkSubscribeMessages API
                    if (res.checkSubscribeMessages === true) {
                        wx.checkSubscribeMessages({
                            success(res) {
                                if (res.errMsg == 'checkSubscribeMessages:ok') {
                                    // 用户已关注公众号
                                    console.log('已关注公众号');
                                } else {
                                    // 用户未关注公众号
                                    console.log('未关注公众号');
                                }
                            },
                            fail(res) {
                                console.log('检查关注公众号失败', res);
                            }
                        });
                    }
                }
            });
        });
    })
}